export const SHOP = {
  // Header
  headerLogo: "header-logo",
  headerCartBtn: "header-cart-btn",
  headerCartCount: "header-cart-count",

  // Hero
  heroCtaShop: "hero-cta-shop",

  // Product
  productCard: (id) => `product-card-${id}`,
  productAddBtn: (id) => `product-add-${id}`,
  productQtyInput: (id) => `product-qty-${id}`,

  // Cart drawer
  cartDrawer: "cart-drawer",
  cartEmpty: "cart-empty",
  cartItem: (id) => `cart-item-${id}`,
  cartQtyMinus: (id) => `cart-qty-minus-${id}`,
  cartQtyPlus: (id) => `cart-qty-plus-${id}`,
  cartRemove: (id) => `cart-remove-${id}`,
  cartTotal: "cart-total",
  cartCheckoutBtn: "cart-checkout-btn",
  cartContinueBtn: "cart-continue-btn",

  // Checkout dialog
  checkoutEmail: "checkout-email",
  checkoutName: "checkout-name",
  checkoutPayBtn: "checkout-pay-btn",

  // Success page
  successQr: "success-qr",
  successRef: "success-ref",
  successDownload: "success-download",
  successHome: "success-home",
  successStatus: "success-status",
};

export const ADMIN = {
  // testid for the password input field on /admin login page (NOT a password value)
  loginPasswordInput: "admin-login-password",
  loginBtn: "admin-login-btn",
  statsRevenue: "admin-stats-revenue",
  statsOrders: "admin-stats-orders",
  statsItems: "admin-stats-items",
  ordersTable: "admin-orders-table",
  productsTable: "admin-products-table",
  redeemInput: "admin-redeem-input",
  redeemBtn: "admin-redeem-btn",
  logoutBtn: "admin-logout-btn",
};
